export default __webpack_public_path__ + "static/bandaid-d946751f2a9bf3e395f66b26f597cab8.png";